import {
  EContentType,
  EMaturityRating,
  EProjectStatus,
  ERole,
  ESystem,
} from 'types/src/types';
import { IUITile } from '../types/ITile';

export const MENU_ITEMS = [
  { id: 1, name: 'How it Works', href: '/about/#how-it-works' },
  { id: 2, name: 'For Gamers', href: '/about/#for-gamers' },
  { id: 3, name: 'Pricing', href: '/about/#pricing' },
];

export const RESET_TIMEZONE = 'America/Chicago';
export const HEADER_HEIGHT = 60;
export const SIDEBAR_WIDTH = 310;

export const GENERAL_LINKS = [
  { id: 1, name: 'About', href: '/about', disabled: false },
  {
    id: 2,
    name: 'Partners',
    href: 'https://sites.google.com/player3.io/partnerprogram?usp=sharing',
    disabled: false,
    external: true,
  },
  { id: 3, name: 'Merch Store', href: '/', disabled: true },
  { id: 4, name: 'Blog', href: '/', disabled: true },
];

export const SUPPORT_LEGAL_LINKS = [
  {
    id: 1,
    name: 'Help',
    href: 'mailto:help@player3.io',
    disabled: false,
    external: true,
  },
  {
    id: 2,
    name: 'Terms',
    href: '/terms-and-conditions/',
    disabled: false,
    external: true,
  },
  {
    id: 3,
    name: 'Privacy',
    href: '/privacy-policy/',
    disabled: false,
    external: true,
  },
];

export const FOR_LIST = [{ id: 1, item: 'For Gamers' },
{ id: 2, item: 'For Devs' }, { id: 3, item: 'For Creators' }];

export const BENEFITS = [
  {
    id: 1,
    text: 'No monthly fees.',
  },
  {
    id: 2,
    text: 'Reduced donation fees.',
  },
  {
    id: 3,
    text: 'Only pay when you earn.',
  },
  {
    id: 4,
    text: 'Supported by gamers & fans.',
  },
];

export const STEPS = [
  {
    id: 1,
    title: 'Create your unique profile',
    description:
      'Design your own gaming showcase with customized blocks that reflect your world.',
  },
  {
    id: 2,
    title: 'Share your content',
    description:
      'Publish devlogs, updates, gameplay, and more—all in one place.',
  },
  {
    id: 3,
    title: 'Earn Support',
    description:
      'Receive donations or offer monthly members-only content to your most loyal fans.',
  },
];

export const STATUSES = [
  { id: 1, status: 'successful', color: 'bg-[#00E73E14]' },
  { id: 2, status: 'pending', color: 'bg-[#1E1E1E0D]' },
  { id: 3, status: 'successful', color: 'bg-[#00E73E14]' },
  { id: 4, status: 'successful', color: 'bg-[#00E73E14]' },
  { id: 5, status: 'failed', color: 'bg-[#FF543E14]' },
  { id: 6, status: 'successful', color: 'bg-[#00E73E14]' },
];

export const TABLE_HEADERS = ['Amount', 'Date', 'Status', 'Paid by'];

export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/; // At least 6 characters, at least one letter and one number

export const uniqueLinkRegex = /^[a-zA-Z0-9-]+$/; // Alphanumeric characters and hyphens only

export const URL_REGEX =
    /(https?:\/\/[^\s]+|www\.[^\s]+|\b[a-z0-9.-]+\.[a-z]{2,}(\/[^\s]*)?)/i;


export const TEXTAREA_MAX_LENGTH = 160;

export const ADD_CONTENT_BUTTONS = [
  {
    icon: 'video',
    title: 'Video',
    type: 'add-video',
  },
  {
    icon: 'imageView',
    title: 'Image',
    type: 'add-image',
  },
  {
    icon: 'note',
    title: 'Note',
    type: 'add-note',
  },
  {
    icon: 'user-transparent',
    title: 'Social',
    type: 'add-social',
  },
];

export const COLS_DESKTOP = 4;
export const COLS_MOBILE = 2;

export const BASE_TILES: IUITile[] = [
  {
    i: 'add-note',
    mx: 0,
    my: 0,
    mw: 1,
    mh: 3,
    x: 0,
    y: 0,
    w: 1,
    h: 3,
    type: 'add-note',
    title: 'Add note...',
    static: true,
    minW: 1,
    minH: 3,
    maxW: 2,
    maxH: 2,
  },
  {
    i: 'add-social',
    x: 1,
    y: 0,
    w: 1,
    h: 3,
    mx: 1,
    my: 0,
    mw: 1,
    mh: 3,
    type: 'add-social',
    title: 'Add social',
    static: true,
    minW: 1,
    minH: 3,
    maxW: 2,
    maxH: 2,
  },
  {
    i: 'add-image',
    x: 2,
    y: 0,
    w: 1,
    h: 3,
    mx: 2,
    my: 0,
    mw: 1,
    mh: 3,
    type: 'add-image',
    title: 'Add image',
    static: true,
    minW: 1,
    minH: 3,
    maxW: 2,
    maxH: 2,
  },
  {
    i: 'add-video',
    x: 3,
    y: 0,
    w: 1,
    h: 3,
    mx: 3,
    my: 0,
    mw: 1,
    mh: 3,
    type: 'add-video',
    title: 'Add video',
    static: true,
    minW: 1,
    minH: 3,
    maxW: 2,
    maxH: 2,
  },
];

export const noBorderStyles = {
  border: 'none',
  outline: 'none',
  boxShadow: 'none',
};

export const TAGS = [
  { name: 'Action', icon: 'action' },
  { name: 'Adventure', icon: 'adventure' },
  { name: 'Classic AI', icon: 'classic ai' },
  { name: 'Co-op', icon: 'co-op' },
  { name: 'Cozy', icon: 'cozy' },
  { name: 'Devlog', icon: 'devlog' },
  { name: 'Fighting', icon: 'fighting' },
  { name: 'Horror', icon: 'horror' },
  { name: 'Metroidvania', icon: 'metroidvania' },
  { name: 'MMO', icon: 'mmo' },
  { name: 'Multiplayer', icon: 'multiplayer' },
  { name: 'Narrative', icon: 'narrative' },
  { name: 'News', icon: 'news' },
  { name: 'Platformer', icon: 'platformer' },
  { name: 'Puzzle', icon: 'puzzle' },
  { name: 'Racing', icon: 'racing' },
  { name: 'Roguelike', icon: 'roguelike' },
  { name: 'RPG', icon: 'rpg' },
  { name: 'Sandbox', icon: 'sandbox' },
  { name: 'Simulation', icon: 'simulation' },
  { name: 'Sports', icon: 'sports' },
  { name: 'Survival', icon: 'survival' },
  { name: 'Updates', icon: 'updates' },
];

export const colorTextPalette = [
  { name: 'Black', value: '#000000' },
  { name: 'Gray', value: '#00000066' },
  { name: 'Green', value: '#02FB45' },
  { name: 'Blue', value: '#4285F4' },
  { name: 'Red', value: '#EA4335' },
];

export const PRESET_AMOUNTS = [2, 5, 10, 15, 20, 30];

export const USER_ROLES = [
  {
    id: ERole.GAME_DEVELOPER,
    title: 'Game Developer',
    icon: 'game-dev',
  },
  {
    id: ERole.CONTENT_CREATOR,
    title: 'Content Creator',
    icon: 'content-creator',
  },
  {
    id: ERole.WRITER_OR_BLOGGER,
    title: 'Writer or Blogger',
    icon: 'blogger',
  },
  {
    id: ERole.GAMER,
    title: 'Gamer',
    icon: 'gamer',
  },
];

export const FINANCIAL_PAGE_TABS = [
  { id: 'earnings', label: 'Earnings & Payouts' },
  { id: 'marketplace', label: 'Shop' },
  { id: 'memberships', label: 'Memberships' },
  { id: 'donations', label: 'Donations' },
  { id: 'history', label: 'History' },
];

export const SETTINGS_PAGE_TABS = [
  { id: 'my-profile', label: 'My profile' },
  { id: 'personal-info', label: 'Personal information' },
  // { id: 'social-connections', label: 'Social connections' },
  // { id: 'plans-billing', label: 'Plans & billing' },
];

export const PROFILE_PAGE_TABS = [
  { id: 'profile', label: 'Profile' },
  { id: 'projects', label: 'Projects' },
  { id: 'social', label: 'Social' },
  { id: 'stories', label: 'Stories' },
];

export const STRIPE_COUNTRIES = [
  'AU',
  'AT',
  'BE',
  'BG',
  'CA',
  'CI',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GH',
  'GI',
  'GR',
  'HK',
  'HU',
  'IN',
  'ID',
  'IE',
  'IT',
  'JP',
  'KE',
  'LV',
  'LI',
  'LT',
  'LU',
  'MY',
  'MT',
  'MX',
  'NL',
  'NZ',
  'NG',
  'NO',
  'PL',
  'PT',
  'RO',
  'SG',
  'SK',
  'SI',
  'ZA',
  'ES',
  'SE',
  'CH',
  'TH',
  'AE',
  'GB',
  'US',
];

export const SYSTEMS = [
  { id: ESystem.MAC, title: 'Mac', icon: 'mac' },
  { id: ESystem.LINUX, title: 'Linux', icon: 'linux' },
  { id: ESystem.WINDOWS, title: 'Windows', icon: 'windows' },
  { id: ESystem.IOS, title: 'iOS', icon: 'ios' },
  { id: ESystem.ANDROID, title: 'Android', icon: 'android' },
];

export const POLICY_ACK_OPTIONS = [
  'No hate speech or harassment',
  'No pornographic or sexually explicit material',
  'No malware, viruses, or harmful scripts',
  'No illegal or infringing material',
  'No misleading or promotional spam',
  'No low-effort or junk content',
  'AI-generated content must follow our guidelines',
  'Respect copyright, no unauthorized use',
];

export const PROJECT_STATUSES = [
  { id: EProjectStatus.PROTOTYPE, title: 'Prototype' },
  { id: EProjectStatus.RELEASED, title: 'Released' },
];

export const CONTENT_TYPES = [
  { id: EContentType.GAME, title: 'Game' },
  { id: EContentType.MOD, title: 'Mod' },
  { id: EContentType.ART, title: 'Art' },
  { id: EContentType.SOUND, title: 'Sound' },
];

export const MATURITY_RATINGS = [
  {
    id: EMaturityRating.EVERYONE,
    title: 'Everyone',
    description: `Content is generally suitable for all ages. May contain minimal cartoon, fantasy, or mild violence and/or frequent use of mild language.`,
    icon: 'everyone',
  },
  {
    id: EMaturityRating.EVERYONE_10,
    title: 'Everyone 10+',
    description:
      'Content is generally suitable for all ages. May contain minimal cartoon, fantasy or mild violence and/or infrequent use of mild language.',
    icon: 'ten-plus',
  },
  {
    id: EMaturityRating.TEEN,
    title: 'Teen',
    description:
      'Content is generally suitable for ages 13 and up. May contain violence, suggestive themes, crude humor, minimal blood, simulated gambling, and/or frequent use of strong language.',
    icon: 'teen',
  },
  {
    id: EMaturityRating.MATURE,
    title: 'Mature 17+',
    description:
      'Content is generally suitable for ages 17 and up. May contain intense violence, blood, and gore, sexual content, and/or strong language.',
    icon: 'mature',
  },
];

export const MB = 1024 * 1024;
export const GB = 1024 * MB;

export const POST_MEDIA_LIMITS = {
  MAX_TOTAL_BYTES: 50 * 1024 * 1024,
  MAX_IMAGES: 4,
  MAX_UPLOADED_VIDEOS: 1,
  MAX_IMAGE_SIZE_BYTES: 50 * 1024 * 1024,
  MAX_VIDEO_SIZE_BYTES: 50 * 1024 * 1024,
  MAX_CHARS: 400,
} as const;
